import { render, staticRenderFns } from "./SetorModule.vue?vue&type=template&id=a1684538"
import script from "./SetorModule.vue?vue&type=script&lang=js"
export * from "./SetorModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports